/**
 * @generated SignedSource<<df41a8d604995f4b55e6d6e671b9fd2f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoSubject_TodoSubject$data = {
  readonly allBreadcrumbs: ReadonlyArray<{
    readonly requiredToDescribeTodo: boolean | null;
    readonly title: string;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"TodoSubjectIcon_TodoSubject">;
  readonly " $fragmentType": "TodoSubject_TodoSubject";
};
export type TodoSubject_TodoSubject$key = {
  readonly " $data"?: TodoSubject_TodoSubject$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoSubject_TodoSubject">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoSubject_TodoSubject",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoSubjectBreadcrumb",
      "kind": "LinkedField",
      "name": "allBreadcrumbs",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requiredToDescribeTodo",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoSubjectIcon_TodoSubject"
    }
  ],
  "type": "TodoSubject",
  "abstractKey": null
};

(node as any).hash = "c0304b9fe9a00646d908974df562fc72";

export default node;
